import React from 'react'
import store from 'store'
import { Provider } from 'react-redux'
import { initGroupSelectorData } from 'actions/projects/form_actions'
import Selector from './selector'

class GroupSelectorApp extends React.Component {

  constructor (props) {
    super(props)
    store.dispatch(initGroupSelectorData({...props}))
  }

  render () {
    return (
      <Provider store={store}>
        <Selector />
      </Provider>
    )
  }
}

export default GroupSelectorApp
